import React from 'react';

// Curved "undo/refresh" arrow used to reactivate a disabled record.
// Kept as a TSX component: plain .svg imports resolve to asset URLs in this CRA setup.
export const refreshOutline = () => {
  return (
    <svg
      width='28'
      height='28'
      viewBox='0 0 28 28'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M12.2929 1.29289C12.6834 0.902369 13.3166 0.902369 13.7071 1.29289L16.7071 4.29289C17.0976 4.68342 17.0976 5.31658 16.7071 5.70711L13.7071 8.70711C13.3166 9.09763 12.6834 9.09763 12.2929 8.70711C11.9024 8.31658 11.9024 7.68342 12.2929 7.29289L13.5734 6.01118C9.35347 6.23289 6 9.72482 6 14C6 18.4183 9.58172 22 14 22C18.4183 22 22 18.4183 22 14C22 12.0052 21.2684 10.1268 19.966 8.67006C19.5979 8.25834 19.6332 7.62616 20.045 7.25805C20.4567 6.88994 21.0889 6.92529 21.457 7.33701C23.0841 9.15693 24 11.5086 24 14C24 19.5228 19.5228 24 14 24C8.47715 24 4 19.5228 4 14C4 8.61352 8.25878 4.22174 13.5929 4.00814L12.2929 2.70711C11.9024 2.31658 11.9024 1.68342 12.2929 1.29289Z'
        fill='#023F80'
      />
    </svg>
  );
};
